<template>
  <div class="slc_w mb-x custom-radio">
    <label
        v-for="option in travelingOptions"
        :key="option.value"
        class="slc"
        :class="{ slc_ac: localValue.includes(option.value) }"
    >
      <input
          name="traveling_by"
          type="checkbox"
          :value="option.value"
          v-model="localValue"
          :checked="localValue.includes(option.value)"
          @change="$emit('update:modelValue', this.localValue)"
          class="hidden"
      />
      <img :src="option.icon" loading="lazy" alt="" class="slc_i" />
      <div>{{ option.label }}</div>
    </label>
  </div>
</template>

<script>
import Options from "@/config/options";
export default {
  name: 'TravelingByRadio',
  props: {
    modelValue: {
      type: Array,
      required: true,
    },
    name: {
      type: String,
      default: 'traveling_by',
    },
  },
  watch: {
    modelValue(){
      if (JSON.stringify(this.localValue) !== JSON.stringify(this.modelValue)) {
        this.localValue = this.modelValue || [];
      }

    }
  },
  data() {
    return {
      travelingOptions: Options.traveling_by,
      localValue: [],
    }
  },
}
</script>

<style scoped></style>
